<template>
  <div id="course-rank">
    <el-row>
      <el-col>
        <div class="page-title-box flex-between">
          <h4 class="page-title">课程讨论排行</h4>
          <div class="page-title date-range">统计范围：{{ countArea }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col>
        <el-card>
          <div class="activity-header flex-align-center mb-3">
            <div class="header-item">
              <el-button
                type="out-line"
                class="return-btn"
                icon="el-icon-arrow-left"
                size="small"
                @click="goBack"
              ></el-button>
            </div>
            <el-button type="primary" size="small" @click="exportTable">导出表格</el-button>
          </div>
          <el-table
            id="discuss-rank-table"
            class="mb-3"
            :data="rankData"
            row-key="id"
            default-expand-all
            stripe=""
          >
            <el-table-column prop="rank" label="排名"></el-table-column>
            <el-table-column width="300" prop="fullname" label="课程全称"></el-table-column>
            <el-table-column width="300" prop="college" label="学院"></el-table-column>
            <el-table-column prop="teacher" label="任课教师"></el-table-column>
            <el-table-column prop="student" label="学生数"></el-table-column>
            <el-table-column prop="rank_num" label="课程讨论数"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rankData: [],
      countArea: '',
    }
  },
  mounted() {
    this.getCourseRankApi()
  },
  methods: {
    async getCourseRankApi() {
      await this.$store
        .dispatch('course/getCourseRank', {
          type: 'table',
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.countArea = res.data.time
            this.rankData = res.data.forum
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    exportTable() {
      //导出名称
      let excelName = '课程讨论排行' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(
        document.querySelector('#discuss-rank-table'),
        xlsxParam
      )
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(
          new Blob([table_write], { type: 'application/octet-stream' }),
          excelName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
}
</script>
<style lang="scss" scoped>
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
  .date-range {
    color: rgba(108, 117, 125, 1);
    font-size: 14px;
  }
}
.return-btn {
  margin-right: 12px;
}
</style>
